import React, { useEffect, useState } from "react";
import { Col, Row, Form } from "react-bootstrap";
import DropDownOsPermission from "../../components/UI/Button/DropDownOsPermission";
import funcionalidades from "../../context/AuthContext.funcionalidades";
import useApiClient, { apiRoutes } from "../../hooks/apiClient";
import TextSpinner from "../../components/UI/Spinner/TextSpinner";
import ListaSpfAccordion from "./Components/ListaSpfAccordion";

const ConsultaGerarOrdemServico = ({ history }) => {
  const [tipoAcao, setTipoAcao] = useState([]);
  const [renderedTipoAcao, setRenderedTipoAcao] = useState([]); // Para controlar os accordions já renderizados
  const { request: requestTipoAcao, data: dataTipoAcao, isLoading } = useApiClient();

  useEffect(() => {
    requestTipoAcao(apiRoutes.fiscalizacao.ordemservico.consultaTipoAcaoSpf);
  }, [requestTipoAcao]);

  useEffect(() => {
    if (dataTipoAcao) {
      setTipoAcao(dataTipoAcao.result || []);
    }
  }, [dataTipoAcao]);

  useEffect(() => {
    const renderAccordionsWithDelay = async () => {
      const delayedAccordions = [];

      await Promise.all(
        tipoAcao.map(
          (item, index) =>
            new Promise((resolve) => {
              setTimeout(() => {
                delayedAccordions.push(item);
                setRenderedTipoAcao([...delayedAccordions]); // Atualiza o estado progressivamente
                resolve();
              }, 400 * index); // Atraso crescente
            }),
        ),
      );
    };

    renderAccordionsWithDelay();
  }, [tipoAcao]);

  return (
    <>
      <Row>
        <Col sm="12">
          <h1 className="h4 mb-4 text-gray-800">Gerar Ordem de Serviço </h1>
        </Col>
      </Row>

      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow mb-4">
            <div className="card-header pt-3 pb-0 flex-row w-100">
              <Form.Group as={Row} className="d-flex flex-row">
                <h6 className="font-weight-bold text-primary flex-grow-1 ml-2 mt-2"> A partir de SPF</h6>
                <Row>
                  <Col sm="12" className="form-inline justify-content-end">
                    <DropDownOsPermission permission={funcionalidades.ordemservico.inserir} history={history} />
                  </Col>
                </Row>
              </Form.Group>
            </div>

            <div className="card-body">
              {isLoading ? (
                <TextSpinner text="Carregando..." />
              ) : (
                renderedTipoAcao.map((item, index) => (
                  <div key={index}>
                    <ListaSpfAccordion item={item} index={index} history={history} />
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConsultaGerarOrdemServico;
